import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';

import './SvgImage.scss';

export const query = graphql`
	fragment SvgImageFragment on Ozk_content_blockModular_blocksCopyContentImageImage_type {
		svg_image {
			alt_text
			svg {
				...AssetFragment
			}
		}
	}
`;

/**
 * @typedef SvgImageOptions
 * @property {string} alt_text
 * @property {import('~/templates/CSTypes').CSFile} svg
 * @property {import('~/templates/CSTypes').CSFile} [mobileSvg]
 *
 * @typedef SvgImageProps
 * @property {SvgImageOptions} options
 */
/** @type {import('~/types/React').ReactFC<SvgImageProps>} */
const SvgImage = ({ options, ...rest }) => {
	if (!options) {
		return null;
	} else if (!options?.svg) {
		console.error('Missing the SVG asset');
		return null;
	}

	return (
		<>
			<MicroSvg
				{...rest}
				className={classNames(rest.className, options.mobileSvg ? 'desktop-svg' : 'both-svg')}
				alt_text={options.alt_text}
				url={options.svg.url}
			/>
			{options.mobileSvg && (
				<MicroSvg
					{...rest}
					className={classNames(rest.className, 'mobile-svg')}
					alt_text={options.alt_text}
					url={options.mobileSvg.url}
				/>
			)}
		</>
	);
};

/** @type {import('react').ReactFC<{ alt_text: string, url: string }>} */
const MicroSvg = ({ alt_text, url, ...rest }) => (
	<object {...rest} data={url} type="image/svg+xml" aria-label={alt_text}>
		{alt_text}
	</object>
);

export default SvgImage;
